export default "__VITE_ASSET__D_h3VWlx__"